<template>
  <div class="faq-item">
    <img :src="icon" alt="icon" class="faq-icon" />
    <h2 class="faq-question">{{ question }}</h2>
    <p class="faq-answer">{{ answer }}</p>
    <p class="faq-note" v-if="note">{{ note }}</p>
  </div>
</template>

<script>
export default {
  name: 'FAQItem',
  props: {
    icon: {
      type: String,
      required: true,
    },
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true,
    },
    note: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.faq-item {
  display: flex;
  flex-direction: column;
  /* align-items: center;
  text-align: center; */
  width: 424px;
}

.faq-icon {
  width: 100px;
  /* height: 50px; */
  margin-bottom: 20px;
}

.faq-question {
  color: var(--Font-navy, #0A1250);
  font-family: "Open Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 33px;
  /* 137.5% */
}

.faq-answer {
  color: #546C92;

  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 150% */
}

.faq-note {
  color: #546C92;
  font-family: "Open Sans";
  font-size: 15px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px;

  &::before {
    content: '*';
    font-style: normal;
    font-weight: 600;
  }
}
</style>
